import { Logo } from '@/component/Icons/Logo';

export const HeaderModal = () => {
  return (
    <header
      className={`!pr-4 !pb-4 !pt-[15px] !pl-[15px] border-b border-slate-100 sm:!px-10`}
    >
      <nav
        className="flex items-center min-h-[36px] max-sm:pl-[6px]"
        aria-label="Global"
      >
        <Logo className="max-sm:h-5 max-sm:w-auto" />
      </nav>
    </header>
  );
};
